import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";

const SelectRateCard = ({
  onSelectRateCard,
  selectedValue,
  rateType = null,
  isDisabled = false, // Add isDisabled prop with default value
}) => {
  const [rateCards, setRateCards] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchRateCards();
  }, [rateType]);

  const fetchRateCards = async () => {
    try {
      const url = `${apiUrl}/ratecard/list${rateType ? `?rate_type=${rateType}` : ""}`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.success && Array.isArray(response.data.rate_cards)) {
        const formattedOptions = response.data.rate_cards
          .filter((rateCard) => rateCard.status === 1) // Only include rate cards with status = 1
          .map((rateCard) => ({
            value: rateCard.rate_card_id,
            label: `${rateCard.rate_name} (${rateCard.rate_type})`,
            rateCardDetails: {
              rate_name: rateCard.rate_name,
              rate_type: rateCard.rate_type,
              start_date: rateCard.start_date,
              end_date: rateCard.end_date,
              room_types: rateCard.room_types,
              pricing_details: rateCard.pricing_details,
              status: rateCard.status,
              corporate_company_id: rateCard.corporate_company_id,
              is_default: rateCard.is_default,
            },
          }));

        setRateCards(formattedOptions);
      } else {
        console.error("Invalid response format:", response.data);
        setRateCards([]);
      }
    } catch (error) {
      console.error("Error fetching rate cards:", error);
      setRateCards([]);
    }
  };

  return (
    <Select
      options={rateCards}
      onChange={onSelectRateCard}
      value={selectedValue}
      placeholder="Select Rate Card"
      isClearable
      isDisabled={isDisabled}
    />
  );
};

export default SelectRateCard;